export default __webpack_public_path__ + "static/media/covergirl.fcfe340f.png";